// source: livongo/protobuf/common/bh/programRecommendation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var livongo_protobuf_common_bh_complaint_pb = require('../../../../livongo/protobuf/common/bh/complaint_pb.js');
goog.object.extend(proto, livongo_protobuf_common_bh_complaint_pb);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.Condition', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.Condition.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.ProgramRecommendation', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.RecommendedStep', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.RecommendedStep.Values', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.common.bh.ProgramRecommendation.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.common.bh.ProgramRecommendation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.bh.ProgramRecommendation.displayName = 'proto.com.livongo.protobuf.common.bh.ProgramRecommendation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.bh.Condition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.bh.Condition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.bh.Condition.displayName = 'proto.com.livongo.protobuf.common.bh.Condition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.bh.RecommendedStep, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.bh.RecommendedStep.displayName = 'proto.com.livongo.protobuf.common.bh.RecommendedStep';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.bh.ProgramRecommendation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryNeed: jspb.Message.getFieldWithDefault(msg, 1, 0),
    topComplaintsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    recommendedStepsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    generatedOnUtc: (f = msg.getGeneratedOnUtc()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.bh.ProgramRecommendation;
  return proto.com.livongo.protobuf.common.bh.ProgramRecommendation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.bh.Condition.Values} */ (reader.readEnum());
      msg.setPrimaryNeed(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.com.livongo.protobuf.common.bh.Complaint.Values>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTopComplaints(values[i]);
      }
      break;
    case 3:
      var values = /** @type {!Array<!proto.com.livongo.protobuf.common.bh.RecommendedStep.Values>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRecommendedSteps(values[i]);
      }
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGeneratedOnUtc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.bh.ProgramRecommendation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryNeed();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTopComplaintsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getRecommendedStepsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getGeneratedOnUtc();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Condition.Values primary_need = 1;
 * @return {!proto.com.livongo.protobuf.common.bh.Condition.Values}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.getPrimaryNeed = function() {
  return /** @type {!proto.com.livongo.protobuf.common.bh.Condition.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.bh.Condition.Values} value
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.setPrimaryNeed = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Complaint.Values top_complaints = 2;
 * @return {!Array<!proto.com.livongo.protobuf.common.bh.Complaint.Values>}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.getTopComplaintsList = function() {
  return /** @type {!Array<!proto.com.livongo.protobuf.common.bh.Complaint.Values>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.common.bh.Complaint.Values>} value
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.setTopComplaintsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.com.livongo.protobuf.common.bh.Complaint.Values} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.addTopComplaints = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.clearTopComplaintsList = function() {
  return this.setTopComplaintsList([]);
};


/**
 * repeated RecommendedStep.Values recommended_steps = 3;
 * @return {!Array<!proto.com.livongo.protobuf.common.bh.RecommendedStep.Values>}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.getRecommendedStepsList = function() {
  return /** @type {!Array<!proto.com.livongo.protobuf.common.bh.RecommendedStep.Values>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.common.bh.RecommendedStep.Values>} value
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.setRecommendedStepsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.com.livongo.protobuf.common.bh.RecommendedStep.Values} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.addRecommendedSteps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.clearRecommendedStepsList = function() {
  return this.setRecommendedStepsList([]);
};


/**
 * optional google.protobuf.Timestamp generated_on_utc = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.getGeneratedOnUtc = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
*/
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.setGeneratedOnUtc = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.bh.ProgramRecommendation} returns this
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.clearGeneratedOnUtc = function() {
  return this.setGeneratedOnUtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.bh.ProgramRecommendation.prototype.hasGeneratedOnUtc = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.bh.Condition.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.bh.Condition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.bh.Condition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.Condition.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.bh.Condition}
 */
proto.com.livongo.protobuf.common.bh.Condition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.bh.Condition;
  return proto.com.livongo.protobuf.common.bh.Condition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.bh.Condition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.bh.Condition}
 */
proto.com.livongo.protobuf.common.bh.Condition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.bh.Condition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.bh.Condition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.bh.Condition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.Condition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.bh.Condition.Values = {
  INVALID: 0,
  TRAUMA: 1,
  PARENTING: 2,
  SLEEP: 3,
  PAIN: 4,
  OPIOID: 5,
  ALCOHOL_AND_DRUGS: 6,
  DEPRESSION: 7,
  ANXIETY: 8,
  EMOTIONS: 9,
  NICOTINE: 10,
  STRESS: 11,
  MINDFULNESS: 12,
  BIPOLAR: 13,
  GRIEF: 14,
  DIVORCE: 15,
  RELATIONSHIPS: 16,
  LIFE_CHANGE: 17,
  WORK_LIFE_BALANCE: 18,
  ADOLESCENT: 19
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.bh.RecommendedStep.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.bh.RecommendedStep} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.bh.RecommendedStep}
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.bh.RecommendedStep;
  return proto.com.livongo.protobuf.common.bh.RecommendedStep.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.bh.RecommendedStep} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.bh.RecommendedStep}
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.bh.RecommendedStep.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.bh.RecommendedStep} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.bh.RecommendedStep.Values = {
  INVALID: 0,
  DIGITAL_COURSE: 1,
  RECOMMENDED_CONTENT: 2,
  THERAPY: 3,
  CLINICAL_COACHING: 4
};

goog.object.extend(exports, proto.com.livongo.protobuf.common.bh);
